import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  DocumentService, MemberService, SportTeamService, FestivalUserService 
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { Gender, Sport } from 'src/core/enums';
import { ModalController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-edit-league',
  templateUrl: './edit-league.component.html',
  styleUrls: ['./edit-league.component.less', '../../core/styles/common.less']
})

export class EditLeagueComponent extends PageClass implements OnInit {

  yearLevels: any[] = [];
  genderList: Gender[];
  sportList: Sport[];

  isLoading: boolean = true;

  @Input() league: any;

  @ViewChild('editLeagueForm', null) editLeagueForm: NgForm;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    private memberService: MemberService,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController
  ) {
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      this.genderList = this.memberService.getGenderList();
      this.sportList =  this.sportTeamService.getSportList();

      this.getYearLevelList();
    } else {
      this.dismissModal();
    }
  }

  private async getYearLevelList() {
    this.yearLevels = this.ageLevelList.slice();
    this.yearLevels = this.yearLevels.sort(this.arrayService.orderByDisplayName);
    
    const yearLevels = this.league.yearLevelList;
    var newYearLevels = [];

    yearLevels.forEach(yearLevel => {
      newYearLevels.push(this.yearLevels.filter(m => m.reference.id == yearLevel.reference.id)[0]);
    });

    this.league.yearLevelList = newYearLevels;
  
    this.isLoading = false;
  }

  resetGender = () => {
    if (this.league.isMixedGender) {
      this.league.gender = null;
    } else {
      this.league.minFemale = null;
      this.league.maxMale = null;
    }
  }

  public async editLeague() {
    if (this.editLeagueForm.invalid) {
      return;
    }

    if (this.league.isMixedGender) {
      this.league.gender = null;
    }

    this.documentService.updateDocument('sportLeagues', this.league);

    this.dismissModal();
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
